export default __webpack_public_path__ + "static/media/Thethree_ImpacCintillo.4de3d4ba.png";